import _ from 'lodash';
import React, { useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
	getSecondsFromTimeRange,
	returnAgeSeconds,
	readableStamp,
} from '../../../../utils/dateFunctions';
import {
	lookupUserById,
} from '../../../../actions/lookups';

const VehicleDataHistorySummarySingle = ({ department_history }) => {
	const dispatch = useDispatch();
	const { all_departments } = useSelector(state => ({
		all_departments: state.settings_departments.original_departments,
	}));
	const department = useMemo(() => {
		const filtered = _.sortBy(_.filter(all_departments, o => o.id === department_history.department_id), 'id');
		return filtered[0] || {};
	}, [all_departments, department_history.department_id]);
	const { totaltime, units } = useMemo(() => {
		let totaltime = department_history.recon_total_24_5 || 0;
		let units = ' hours';
		if (totaltime > 0) {
			if (totaltime > (24 * 60 * 60)) {
				totaltime /= (24 * 60 * 60);
				units = ' days';
			} else {
				totaltime /= (60 * 60);
			}
		} else if (department_history.current === true) {
			if (totaltime > (24 * 60 * 60)) {
				totaltime /= (24 * 60 * 60);
				units = ' days';
			} else {
				totaltime /= (60 * 60);
			}
		} else {
			if (totaltime > (24 * 60 * 60)) {
				totaltime /= (24 * 60 * 60);
				units = ' days';
			} else {
				totaltime /= (60 * 60);
			}
		}
		return { totaltime, units };
	}, [department_history]);
	const user_name = useMemo(() => {
		if (!department_history.recon_entered_by) return 'N/A';
		const user_id = dispatch(lookupUserById(department_history.recon_entered_by));
		return user_id && user_id.user_name ? user_id.user_name : 'N/A';
	}, [dispatch, department_history.recon_entered_by]);
	const completed_user_name = useMemo(() => {
		if (!department_history.recon_ended_by) return 'N/A';
		const user_id_completed = dispatch(lookupUserById(department_history.recon_ended_by));
		return user_id_completed && user_id_completed.user_name ? user_id_completed.user_name : 'N/A';
	}, [dispatch, department_history.recon_ended_by]);
	const unit = useMemo(() => (
		<span className="float-right">
			{totaltime.toFixed(1)}
			{' '}
			{units}
		</span>
	), [totaltime, units]);
	const isStartTimeBlank = !department_history.recon_starttime || department_history.recon_starttime === '';

	return (
		<li key={`timeline_single_${department_history.id}`}>
			<div className="timeline-badge">
				<i className="fas fa-check-circle" />
			</div>
			<div className="timeline-panel bg-light box">
				<div className="timeline-heading">
					<h4 className="timeline-title text-capitalize">
						{department.name || 'Unknown Department'}
						{' '}
						{unit}
					</h4>
					<p>
						<small className="text-muted">
							<i className="glyphicon glyphicon-time" />
							{' '}Initiated At:
							{' '}
							<span className="text-primary">
								{isStartTimeBlank ? 'N/A' : readableStamp(department_history.recon_starttime)}
							</span>
							{' '}By:{' '}
							<span className="text-success">{user_name}</span>
						</small>
						<br />
						{department_history.recon_endtime ? (
							<small className="text-muted">
								<i className="glyphicon glyphicon-time" />
								{' '}Completed At:
								{' '}
								<span className="text-primary">{readableStamp(department_history.recon_endtime)}</span>
								{' '}By:{' '}
								<span className="text-success">{completed_user_name}</span>
							</small>
						) : (
							<small className="text-muted">
								<i className="glyphicon glyphicon-time" />
								{' '}In Progress
							</small>
						)}
					</p>
				</div>
				<div className="timeline-body" />
			</div>
		</li>
	);
};

export default VehicleDataHistorySummarySingle;